/*
 * Copyright (c) 2025 curryfirm.com
 */

import { createListenerMiddleware, isAnyOf } from "@reduxjs/toolkit";
import { markRouteStale } from "./routingSlice.js";
import {
    setConfirmedDumpLocationIds,
    setLocationChoosingMode,
    setLocationDropLot,
    setLocationCustomAddress,
    setWizardLocationId,
    setChosenDumpsterIds,
    resetWorkflow,
    setStoredRouteType,
} from "../workflow/workflowSlice.js";

const routingInputsChangeListener = createListenerMiddleware();

routingInputsChangeListener.startListening({
    matcher: isAnyOf(
        setStoredRouteType,
        setConfirmedDumpLocationIds, // affects dump sites
        setLocationChoosingMode,     // could switch between current/drop-lot/custom mode
        setLocationDropLot,          // changes chosen drop-lot location
        setLocationCustomAddress,    // changes custom location input
        setWizardLocationId,         // affects "current" location reference
        setChosenDumpsterIds,
        resetWorkflow,               // clears everything (route is now invalid)
    ),

    effect: async (action, listenerApi) => {
        listenerApi.dispatch(markRouteStale());
    },
});

export default routingInputsChangeListener;
